<template>
    <div>
        <div slot="footer">
            <vs-row vs-justify="flex-start">
                <b-col>
                    <vs-button size="small" color="success" icon-pack="feather" icon="icon-search"
                        style="border-radius: 5px" @click="cekiDetayList()"
                        v-b-tooltip.hover.bottom="'Sipariş Detay'"></vs-button>
                </b-col>
                <b-col>
                    <vs-button size="small" color="primary" icon-pack="feather" icon="icon-edit"
                        style="border-radius: 5px" @click="cekiListDuzenle()"
                        v-b-tooltip.hover.bottom="'Duzenle'"></vs-button>
                </b-col>

            </vs-row>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        cekiDetayList() {

            console.log(this.params.data);

            let routeData = this.$router.resolve({
                name: "cekiDetay",
                params: { orderNumber: this.params.data["Sevk Numarası"], orderDate: this.params.data["Sipariş Tarihi"] },
            });
            window.open(routeData.href, "_blank");
        },
        cekiListDuzenle() {
            this.$root.$emit("siparisKalemiSec", this.params.data);
        },

    }
}
</script>